import React, { useState } from 'react'
import { Box, Grid } from '@mui/material'
import { makeStyles } from '@material-ui/core/styles'
import MotorPriceDetails from 'src/components/BuyPolicy/insuranceScreens/motor/MotorPriceDetails'
import VehicleDetails from 'src/components/BuyPolicy/insuranceScreens/motor/VehicleDetails'
import BackArrow from 'src/assets/Buy_Policy_Images/arrow.svg'
import MotorDetailsForm from 'src/components/BuyPolicy/insuranceScreens/motor/MotorDetailsForm'
import { useHistory } from 'react-router-dom'
import ContactUs from 'src/components/BuyPolicy/insuranceScreens/health/ContactUs'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import moment from 'moment'
import {
  showNotificationMessage,
  updateMotorNomineeDetails,
  updatePersonalDetailsMotor,
  updateVehicleDetailsMotor,
} from 'src/actions'
import {
  AADHAR_NO_REGEX,
  MOTOR_MEMBER_DETAILS_VALIDATIONS,
  NAME_REGEX,
  PAN_NO_REGEX,
  PHONE_REGEX,
  PINCODE_REGEX,
} from 'src/utils/constants/BuyPolicyMotor'
import { useDispatch, useSelector } from 'react-redux'
import { getAddress } from 'src/services/buyPolicyService'
import Modal from '@mui/material/Modal'
import {
  getMotorFullQuoteRequestBody,
  verifyKYCForMotor,
} from 'src/services/buyPolicyMotorService'
import VerifyKycModal from '../../modals/VerifyKycModal'
import {
  cKYC_LIST,
  COMPANY,
  ERROR_ON_KYC,
  ERROR_ON_STATE_AND_CITY,
} from 'src/utils/constants/BuyPolicy'
import LoadingModal from 'src/components/common/LoadingModal'
import { NOTIFICATION_TYPES } from 'src/utils/constants/common'
import { VEHICLE_TYPE } from 'src/utils/constants/BuyPolicyBike'
import { verifyKYCForBike } from 'src/services/buyPolicyBikeService'
import { POLICYHOLDERTYPE_SMALLCASE } from 'src/utils/constants/Individual'
import { NOTIFICATION_MSG_REPORTS } from 'src/utils/constants/CustomerReports'
import { MOTOR_INS_FORMIK } from 'src/utils/constants/Motor'

const MotorInsuranceMemberDetails = () => {
  const history = useHistory()
  const classes = useStyles()
  const dispatch = useDispatch()
  const [openKYC, setOpenKYC] = useState(false)
  const [loading, setLoading] = useState(false)
  const motorDetails = useSelector((state) => state?.buyPolicyMotorReducer)
  const paCoverDetails = useSelector((state) => state?.paCoverAmountReducer)
  const vehicleDetails = motorDetails?.vehicleDetails
  const personalDetails = motorDetails?.personalDetails
  const nomineeDetails = motorDetails?.nomineeDetails
  const [, setOpenAlert] = useState(false)
  const [, setAlertMessage] = useState('')
  const initalStateValues = {
    manufacturingYear: '',
    manufacturingMonth: '',
    carOwnedBy: '',
    companyName: '',
    companyPan: '',
    companyGstin: '',
    externalCngLpgKit: '',
    externalCngLpgKitAmount: undefined,
    isCurrentCarLoan: '',
    currentCarLoanProvider: '',
    engineNumber: '',
    chassisNumber: '',
    firstName: '',
    lastName: '',
    email: '',
    mobileNumber: '',
    fullAddress: '',
    pincode: '',
    city: '',
    state: '',
    dateOfBirth: '',
    gender: '',
    pan: '',
    aadhar: '',
    nomineeFirstName: '',
    nomineeLastName: '',
    nomineeDOB: '',
    nomineeRelation: '',
    nomineeGender: '',
    companyIncorporationDate: '',
  }
  const getNextPath = () => {
    if (motorDetails.vehicleDetails.vehicleType === VEHICLE_TYPE?.TWO_WHEELER) {
      history.push(
        '/individual/dashboard/buyPolicy/bike/insuranceDetails/terms-and-conditions'
      )
    } else {
      history.push(
        '/individual/dashboard/buyPolicy/motor/insuranceDetails/terms-and-conditions'
      )
    }
  }
  const formMotorDetails = useFormik({
    initialValues: initalStateValues,
    validationSchema: Yup.object({
      carOwnedBy: Yup.string().required(
        MOTOR_MEMBER_DETAILS_VALIDATIONS?.carOwnedBy
      ),
      companyName: Yup.string()
        .nullable(true)
        .when(MOTOR_INS_FORMIK?.CAROWNEDBY, {
          is: MOTOR_INS_FORMIK?.COMPANY,
          then: Yup.string().required(
            MOTOR_MEMBER_DETAILS_VALIDATIONS?.companyName
          ),
        }),
      companyPan: Yup.string()
        .nullable(true)
        .when(MOTOR_INS_FORMIK?.CAROWNEDBY, {
          is: MOTOR_INS_FORMIK?.COMPANY,
          then: Yup.string().required(
            MOTOR_MEMBER_DETAILS_VALIDATIONS?.companyPan
          ),
        }),
      companyIncorporationDate: Yup.string()
        .nullable(true)
        .when(MOTOR_INS_FORMIK?.CAROWNEDBY, {
          is: MOTOR_INS_FORMIK?.COMPANY,
          then: Yup.string().required(
            MOTOR_MEMBER_DETAILS_VALIDATIONS?.companyIncorporationDate
          ),
        }),
      companyGstin: Yup.string()
        .nullable(true)
        .when(MOTOR_INS_FORMIK?.CAROWNEDBY, {
          is: MOTOR_INS_FORMIK?.COMPANY,
          then: Yup.string().nullable(true),
        }),
      externalCngLpgKit: Yup.string().required(
        MOTOR_MEMBER_DETAILS_VALIDATIONS?.externalCngLpgKit
      ),
      externalCngLpgKitAmount: Yup.number().when(
        MOTOR_INS_FORMIK?.EXTERNALCNGLPGKIT,
        {
          is: MOTOR_INS_FORMIK?.YES,
          then: Yup.number()
            .required(MOTOR_MEMBER_DETAILS_VALIDATIONS?.externalCngLpgKitAmount)
            .min(10000, MOTOR_INS_FORMIK?.MIN_AMT_SHOULDBE)
            .max(50000, MOTOR_INS_FORMIK?.MAX_AMT_SHOULDBE),
        }
      ),
      isCurrentCarLoan: Yup.string().required(
        MOTOR_MEMBER_DETAILS_VALIDATIONS?.isCurrentCarLoan
      ),

      currentCarLoanProvider: Yup.object()
        .shape({
          id: Yup.string(),
          loanProvider: Yup.string(),
        })
        .when(MOTOR_INS_FORMIK?.ISCURRENTCARLOAN, {
          is: MOTOR_INS_FORMIK?.YES,
          then: Yup.object()
            .shape({
              id: Yup.string(),
              loanProvider: Yup.string(),
            })
            .required(MOTOR_MEMBER_DETAILS_VALIDATIONS?.currentCarLoanProvider),
        }),
      engineNumber: Yup.string().required(
        MOTOR_MEMBER_DETAILS_VALIDATIONS?.engineNumber
      ),
      chassisNumber: Yup.string().required(
        MOTOR_MEMBER_DETAILS_VALIDATIONS?.chassisNumber
      ),
      branchName: Yup.string().when(MOTOR_INS_FORMIK?.ISCURRENTCARLOAN, {
        is: MOTOR_INS_FORMIK?.YES,
        then: Yup.string().required(
          MOTOR_MEMBER_DETAILS_VALIDATIONS?.branchName
        ),
      }),
      firstName: Yup.string()
        .required(MOTOR_MEMBER_DETAILS_VALIDATIONS?.firstName)
        .matches(
          NAME_REGEX,
          MOTOR_MEMBER_DETAILS_VALIDATIONS?.isValidNameValidation
        ),
      lastName: Yup.string()
        .required(MOTOR_MEMBER_DETAILS_VALIDATIONS?.lastName)
        .matches(
          NAME_REGEX,
          MOTOR_MEMBER_DETAILS_VALIDATIONS?.isValidNameValidation
        ),
      email: Yup.string()
        .required(MOTOR_MEMBER_DETAILS_VALIDATIONS?.email)
        .email(MOTOR_MEMBER_DETAILS_VALIDATIONS?.emailValidation),
      mobileNumber: Yup.string()
        .required(MOTOR_MEMBER_DETAILS_VALIDATIONS?.mobileNumber)
        .matches(
          PHONE_REGEX,
          MOTOR_MEMBER_DETAILS_VALIDATIONS?.phoneValidation
        ),
      dateOfBirth: Yup.string()
        .required(MOTOR_MEMBER_DETAILS_VALIDATIONS?.dateOfBirth)
        .test(MOTOR_INS_FORMIK?.AGE, MOTOR_INS_FORMIK?.MUST_BE18, (date) => {
          const minAge = 18
          const dob = moment(date)
          const today = moment()
          return today.diff(dob, 'years') >= minAge
        }),
      gender: Yup.string().required(MOTOR_MEMBER_DETAILS_VALIDATIONS?.gender),
      pan: Yup.string()
        .required(MOTOR_MEMBER_DETAILS_VALIDATIONS?.pan)
        .matches(PAN_NO_REGEX, MOTOR_MEMBER_DETAILS_VALIDATIONS?.panValidation),
      aadhar: Yup.string().matches(
        AADHAR_NO_REGEX,
        MOTOR_MEMBER_DETAILS_VALIDATIONS?.aadharValidation
      ),
      nomineeFirstName: Yup.string()
        .required(MOTOR_MEMBER_DETAILS_VALIDATIONS?.nomineeFirstName)
        .matches(
          NAME_REGEX,
          MOTOR_MEMBER_DETAILS_VALIDATIONS?.isValidNameValidation
        ),
      nomineeLastName: Yup.string()
        .required(MOTOR_MEMBER_DETAILS_VALIDATIONS?.nomineeLastName)
        .matches(
          NAME_REGEX,
          MOTOR_MEMBER_DETAILS_VALIDATIONS?.isValidNameValidation
        ),
      nomineeDOB: Yup.string().required(
        MOTOR_MEMBER_DETAILS_VALIDATIONS?.nomineeDOB
      ),
      nomineeRelation: Yup.string().required(
        MOTOR_MEMBER_DETAILS_VALIDATIONS?.nomineeRelation
      ),
      nomineeGender: Yup.string().required(
        MOTOR_MEMBER_DETAILS_VALIDATIONS?.nomineeGender
      ),
      manufacturingYear: Yup.string().required(
        MOTOR_MEMBER_DETAILS_VALIDATIONS?.manufacturingYear
      ),
      manufacturingMonth: Yup.string().required(
        MOTOR_MEMBER_DETAILS_VALIDATIONS?.manufacturingMonth
      ),
      fullAddress: Yup.string().required(
        MOTOR_MEMBER_DETAILS_VALIDATIONS?.fullAddress
      ),
      pincode: Yup.string()
        .required(MOTOR_MEMBER_DETAILS_VALIDATIONS?.pincode)
        .matches(
          PINCODE_REGEX,
          MOTOR_MEMBER_DETAILS_VALIDATIONS?.pincodeValidation
        ),
      city: Yup.string().required(MOTOR_MEMBER_DETAILS_VALIDATIONS?.city),
      state: Yup.string().required(MOTOR_MEMBER_DETAILS_VALIDATIONS?.state),
    }),
    onSubmit: (values, { setSubmitting }) => {
      handleSubmit(values, setSubmitting)
    },
    enableReinitialize: true,
  })
  const handleSubmit = async (values, setSubmitting) => {
    setSubmitting(true)
    dispatch(
      updateVehicleDetailsMotor({
        ...vehicleDetails,
        companyName: values?.companyName,
        yearOfManufacturer: values?.manufacturingYear,
        monthOfManufacturer: values?.manufacturingMonth,
        companyPAN: values?.companyPan,
        companyIncorporationDate: values?.companyIncorporationDate,
        companyGSTIN: values?.companyGstin,
        externalCngLpgKit: values?.externalCngLpgKit,
        externalCngLpgKitAmount: values?.externalCngLpgKitAmount,
        isCurrentCarLoan: values?.isCurrentCarLoan,
        loanProviderName: values?.currentCarLoanProvider,
        branchName: values?.branchName,
        carOwnedBy: values?.carOwnedBy,
        engineNumber: values?.engineNumber,
        chassisNumber: values?.chassisNumber,
      })
    )
    dispatch(
      updatePersonalDetailsMotor({
        ...personalDetails,
        firstName: values?.firstName,
        lastName: values?.lastName,
        mobileNumber: values?.mobileNumber,
        email: values?.email,
        dateOfBirth: values?.dateOfBirth,
        gender: values?.gender,
        fullAddress: values?.fullAddress,
        pincode: values?.pincode,
        city: values?.city,
        state: values?.state,
        pan: values?.pan?.toUpperCase(),
        aadhar: values?.aadhar,
      })
    )
    dispatch(
      updateMotorNomineeDetails({
        ...nomineeDetails,
        nomineeFirstName: values?.nomineeFirstName,
        nomineeLastName: values?.nomineeLastName,
        nomineeDOB: values?.nomineeDOB,
        nomineeGender: values?.nomineeGender,
        nomineeRelationType: values?.nomineeRelation,
      })
    )
    if (cKYC_LIST?.includes(motorDetails?.selectedQuote?.providerId)) {
      setOpenKYC(true)
    } else {
      getNextPath()
    }
  }
  const handlePrefillData = () => {
    formMotorDetails.setValues({
      ...personalDetails,
      ...nomineeDetails,
      ...vehicleDetails,
      carOwnedBy: vehicleDetails?.isCompany
        ? COMPANY
        : POLICYHOLDERTYPE_SMALLCASE?.INDIVIDUAL,
    })

    formMotorDetails.setFieldValue(
      MOTOR_INS_FORMIK?.COMPANY_NAME,
      vehicleDetails?.companyName
    )
    formMotorDetails.setFieldValue(
      MOTOR_INS_FORMIK?.CITY,
      personalDetails?.city
    )
    formMotorDetails.setFieldValue(
      MOTOR_INS_FORMIK?.PINCODE,
      personalDetails?.pincode
    )
    formMotorDetails.setFieldValue(
      MOTOR_INS_FORMIK?.STATE,
      personalDetails?.state
    )
    formMotorDetails.setFieldValue(
      MOTOR_INS_FORMIK?.FIRSTNAME,
      personalDetails?.name
    )
    formMotorDetails.setFieldValue(
      MOTOR_INS_FORMIK?.COMPANY_INCORPORATION_DATE,
      vehicleDetails?.companyIncorporationDate
    )
    formMotorDetails.setFieldValue(
      MOTOR_INS_FORMIK?.ISCOMPANY,
      vehicleDetails?.isCompany
    )
    formMotorDetails.setFieldValue(
      MOTOR_INS_FORMIK?.COMPANYPAN,
      vehicleDetails?.companyPAN
    )
    formMotorDetails.setFieldValue(
      MOTOR_INS_FORMIK?.COMPANY_GSTIN,
      vehicleDetails?.companyGSTIN
    )
    formMotorDetails.setFieldValue(
      MOTOR_INS_FORMIK?.MANUFACTURINGYEAR,
      vehicleDetails?.yearOfManufacturer
    )
    formMotorDetails.setFieldValue(
      MOTOR_INS_FORMIK?.NOMINEE_RELATION,
      nomineeDetails?.nomineeRelationType
    )
    formMotorDetails.setFieldValue(
      MOTOR_INS_FORMIK?.LASTNAME,
      personalDetails?.lastName
    )
    formMotorDetails.setFieldValue(
      MOTOR_INS_FORMIK?.EXTERNALCNGLPGKIT,
      vehicleDetails?.externalCngLpgKit
    )
    formMotorDetails.setFieldValue(
      MOTOR_INS_FORMIK?.ISCURRENTCARLOAN,
      vehicleDetails?.isCurrentCarLoan
    )
    formMotorDetails.setFieldValue(
      MOTOR_INS_FORMIK?.CURRENTLOANPROVIDER,
      vehicleDetails?.loanProviderName
    )
    formMotorDetails.setFieldValue(
      MOTOR_INS_FORMIK?.ENGINENUMBER,
      vehicleDetails?.engineNumber
    )
    formMotorDetails.setFieldValue(
      MOTOR_INS_FORMIK?.CHASSISNUMBER,
      vehicleDetails?.chassisNumber
    )
    formMotorDetails.setFieldValue(
      MOTOR_INS_FORMIK?.MANUFACTURINGMONTH,
      vehicleDetails?.monthOfManufacturer
    )
  }

  const fetchFullAddress = async (pincode) => {
    const response = await getAddress(pincode)
    try {
      if (response?.res?.status !== 200) {
        setAlertMessage(
          NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME
        )
        setOpenAlert(true)
      }
      // Success
      const responseData = response?.res?.data
      if (responseData) {
        await formMotorDetails.setFieldValue(
          'state',
          responseData?.[0]?.PostOffice?.[0]?.State
        )
        await formMotorDetails.setFieldValue(
          'city',
          responseData?.[0]?.PostOffice?.[0]?.Division
        )
      } else {
        setOpenAlert(true)
        setAlertMessage(responseData?.message)
      }
    } catch (err) {
      setAlertMessage(ERROR_ON_STATE_AND_CITY)
      setOpenAlert(true)
    }
  }
  const handleBack = () => {
    history.goBack()
  }

  const closeModal = () => {
    setOpenKYC(false)
  }

  const getPACoverObject = (paObject, providerId) => {
    if (Object?.prototype?.hasOwnProperty?.call(paObject, providerId)) {
      return { [providerId]: paObject?.[providerId] }
    }
    return null
  }

  const getKYCRequestBody = (motorDetails) => {
    return {
      kycInfo: {
        pan: motorDetails?.personalDetails?.pan,
        dob: motorDetails?.personalDetails?.dateOfBirth,
        enquiryId: motorDetails?.selectedQuote?.enquiryId,
        providerId: motorDetails?.selectedQuote?.providerId,
      },
      fullQuoteRequest: getMotorFullQuoteRequestBody(motorDetails),
      quickQuoteResponse: { ...motorDetails?.selectedQuote },
      fieldValues: {
        vehicleType: vehicleDetails?.vehicleType,
        state: personalDetails?.state,
        city: personalDetails?.city,
        paDetails: getPACoverObject(
          paCoverDetails?.paCoverValues,
          motorDetails?.selectedQuote?.providerId
        ),
      },
    }
  }

  const fetchKYCStatus = async (token, proposerKYCDetails) => {
    const personalDetails = {
      ...motorDetails?.personalDetails,
      pan: proposerKYCDetails?.panNumber?.value,
      dateOfBirth: proposerKYCDetails?.dateOfBirth?.value,
    }
    dispatch(updatePersonalDetailsMotor(personalDetails))
    const updatedmotorDetails = {
      ...motorDetails,
      personalDetails: personalDetails,
    }
    const formData = getKYCRequestBody(updatedmotorDetails)
    setLoading(true)
    const response =
      vehicleDetails?.vehicleType === VEHICLE_TYPE?.TWO_WHEELER
        ? await verifyKYCForBike(token, formData)
        : await verifyKYCForMotor(token, formData)
    try {
      if (response?.res?.status !== 200) {
        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
          })
        )
      }
      // Success
      setLoading(false)
      const responseData = response?.res?.data
      if (responseData?.kycStatus) {
        getNextPath()
      } else {
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: responseData?.failureMsg,
          })
        )
        window.open(responseData.kycUrl, '_self')
      }
    } catch (err) {
      setLoading(false)
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES?.ERROR,
          message: ERROR_ON_KYC,
        })
      )
    }
  }

  return (
    <>
      {openKYC ? (
        <Modal id='modal' open={openKYC} onClose={closeModal}>
          <div className={'modal-container'}>
            <VerifyKycModal
              closeModal={closeModal}
              verifyKYCFunction={fetchKYCStatus}
              pan={motorDetails.personalDetails.pan}
              dateOfBirth={motorDetails.personalDetails.dateOfBirth}
              quoteDetails={motorDetails.selectedQuote}
            />
          </div>
        </Modal>
      ) : null}

      <LoadingModal loading={loading} />
      <Box className={classes.componentBackground}>
        <Box className={classes.componentElement}>
          <Box className={classes.containerMain}>
            <Grid container spacing={2} direction='column'>
              <Grid item xs={12}>
                <VehicleDetails isEdit={false} />
              </Grid>
              <Grid item container direction='row' spacing={2}>
                <Grid item xs={12} md={8.2}>
                  <Box className={classes.userDetailsContainer}>
                    <Box>
                      <Box
                        className={classes.conatinerBack}
                        onClick={handleBack}
                      >
                        <img src={BackArrow} alt='back-arrow-img' />
                        <Box className={classes.conatinerBackText}>
                          Go back to Quotes
                        </Box>
                      </Box>
                    </Box>
                    <Box>
                      <Box className={classes.userDetailsContainerText}>
                        Great! Please confirm your details
                      </Box>
                      <Box
                        className={classes.userDetailsContainerTextSecondary}
                      >
                        Refer to your RC or previous policy copy for the filling
                        below details
                      </Box>
                    </Box>
                    <Box>
                      <MotorDetailsForm
                        formMotorDetails={formMotorDetails}
                        fetchFullAddress={fetchFullAddress}
                        handlePrefillData={handlePrefillData}
                      />
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={12} md={3.8}>
                  <MotorPriceDetails formMotorDetails={formMotorDetails} />
                  <Box className={classes.contactSection}>
                    <ContactUs color='linear-gradient(142.32deg, #4DC3E3 -476.58%, #FFFFFF 81.03%)' />
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Box>
    </>
  )
}

export default MotorInsuranceMemberDetails

const useStyles = makeStyles({
  containerMain: {
    padding: '10px 0px 60px 0px',
    background: 'linear-gradient(180deg, #DFF7FF 4.08%, #FFFFFF 102.47%)',
    backgroundSize: '100% 40%',
    backgroundRepeat: 'no-repeat',
    backgroundColor: '#FFFFFF',
  },
  userDetailsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
    paddingTop: 10,
  },
  conatinerBack: {
    display: 'flex',
    flexDirection: 'row',
    gap: 10,
    cursor: 'pointer',
  },
  conatinerBackText: {
    fontFamily: 'Roboto',
    fontSize: '0.8125em',
    fontWeight: 400,
    lineHeight: '0.9375em',
    letterSpacing: '0em',
    color: '#3E3E3E',
  },
  userDetailsContainerText: {
    fontFamily: 'Roboto',
    fontSize: '1.125em',
    fontWeight: 500,
    lineHeight: '1.6875em',
    letterSpacing: '0em',
    color: '#000000',
  },
  userDetailsContainerTextSecondary: {
    fontFamily: 'Roboto',
    fontSize: '0.8125em',
    fontWeight: 400,
    lineHeight: '1.25em',
    letterSpacing: '0em',
    color: '#7C7C7C',
  },
  componentElement: {
    maxWidth: '1240px !important',
    width: '100%',
    padding: '10px 0px 10px 0px',
  },
  componentBackground: {
    background: 'linear-gradient(180deg, #DFF7FF 4.08%, #FFFFFF 102.47%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundSize: '100% 40%',
    backgroundRepeat: 'no-repeat',
    backgroundColor: '#FFFFFF',
  },
  rightColumn: {
    display: 'flex',
    flexDirection: 'row',
    gap: 20,
  },
  contactSection: {
    padding: '20px',
  },
})
